
import { WorldCountry } from '../types';
import { thailandExpanded } from './thailandExpansion';

export const southeastAsiaExpansion: WorldCountry[] = [
  thailandExpanded,
  
  // Malasia expandida
  {
    code: 'MY',
    name: 'Malaysia',
    slug: 'malaysia',
    population: 33573000,
    topCities: [
      { name: 'Kuala Lumpur', slug: 'kuala-lumpur', population: 1768000 },
      { name: 'George Town', slug: 'george-town', population: 708127 },
      { name: 'Ipoh', slug: 'ipoh', population: 657892 },
      { name: 'Shah Alam', slug: 'shah-alam', population: 641306 },
      { name: 'Petaling Jaya', slug: 'petaling-jaya', population: 613977 },
      { name: 'Klang', slug: 'klang', population: 879867 },
      { name: 'Johor Bahru', slug: 'johor-bahru', population: 497067 },
      { name: 'Subang Jaya', slug: 'subang-jaya', population: 648350 },
      { name: 'Kuching', slug: 'kuching', population: 325132 },
      { name: 'Kota Kinabalu', slug: 'kota-kinabalu', population: 452058 },
      
      // Expanded to 100 cities
      { name: 'Seremban', slug: 'seremban', population: 515490 },
      { name: 'Kuantan', slug: 'kuantan', population: 427515 },
      { name: 'Kajang', slug: 'kajang', population: 795522 },
      { name: 'Alor Setar', slug: 'alor-setar', population: 405523 },
      { name: 'Melaka', slug: 'melaka', population: 484885 },
      { name: 'Kota Bharu', slug: 'kota-bharu', population: 491237 },
      { name: 'Kuala Terengganu', slug: 'kuala-terengganu', population: 343284 },
      { name: 'Miri', slug: 'miri', population: 300543 },
      { name: 'Sandakan', slug: 'sandakan', population: 396290 },
      { name: 'Tawau', slug: 'tawau', population: 397673 },
      { name: 'Ampang Jaya', slug: 'ampang-jaya', population: 462616 },
      { name: 'Selayang', slug: 'selayang', population: 542409 },
      { name: 'Cheras', slug: 'cheras', population: 932581 },
      { name: 'Sungai Petani', slug: 'sungai-petani', population: 228843 },
      { name: 'Taiping', slug: 'taiping', population: 245182 },
      { name: 'Sibu', slug: 'sibu', population: 162676 },
      { name: 'Bintulu', slug: 'bintulu', population: 114058 },
      { name: 'Kangar', slug: 'kangar', population: 48898 },
      { name: 'Putrajaya', slug: 'putrajaya', population: 109202 },
      { name: 'Cyberjaya', slug: 'cyberjaya', population: 50000 },
      { name: 'Sepang', slug: 'sepang', population: 212050 },
      { name: 'Nilai', slug: 'nilai', population: 85000 },
      { name: 'Port Dickson', slug: 'port-dickson', population: 115256 },
      { name: 'Kulim', slug: 'kulim', population: 107813 },
      { name: 'Kuala Kedah', slug: 'kuala-kedah', population: 35000 },
      { name: 'Sik', slug: 'sik', population: 18500 },
      { name: 'Baling', slug: 'baling', population: 15000 },
      { name: 'Pendang', slug: 'pendang', population: 18000 },
      { name: 'Kubang Pasu', slug: 'kubang-pasu', population: 120000 },
      { name: 'Padang Terap', slug: 'padang-terap', population: 70000 },
      { name: 'Pokok Sena', slug: 'pokok-sena', population: 51000 },
      { name: 'Yan', slug: 'yan', population: 95000 },
      { name: 'Kuala Muda', slug: 'kuala-muda', population: 485000 },
      { name: 'Kuala Nerang', slug: 'kuala-nerang', population: 25000 },
      { name: 'Bandar Baharu', slug: 'bandar-baharu', population: 35000 },
      { name: 'Selama', slug: 'selama', population: 18000 },
      { name: 'Parit Buntar', slug: 'parit-buntar', population: 65000 },
      { name: 'Bukit Mertajam', slug: 'bukit-mertajam', population: 13000 },
      { name: 'Nibong Tebal', slug: 'nibong-tebal', population: 165000 },
      { name: 'Permatang Pauh', slug: 'permatang-pauh', population: 58000 },
      { name: 'Tasek Gelugor', slug: 'tasek-gelugor', population: 35000 },
      { name: 'Air Itam', slug: 'air-itam', population: 45000 },
      { name: 'Bayan Lepas', slug: 'bayan-lepas', population: 95000 },
      { name: 'Balik Pulau', slug: 'balik-pulau', population: 72000 },
      { name: 'Jelutong', slug: 'jelutong', population: 65000 },
      { name: 'Gelugor', slug: 'gelugor', population: 195000 },
      { name: 'Tanjung Tokong', slug: 'tanjung-tokong', population: 35000 },
      { name: 'Gurney Drive', slug: 'gurney-drive', population: 25000 },
      { name: 'Komtar', slug: 'komtar', population: 15000 },
      { name: 'Penang Hill', slug: 'penang-hill', population: 5000 },
      { name: 'Botanic Gardens', slug: 'botanic-gardens', population: 8000 },
      { name: 'Batu Ferringhi', slug: 'batu-ferringhi', population: 25000 },
      { name: 'Tanjung Bungah', slug: 'tanjung-bungah', population: 18000 },
      { name: 'Pulau Tikus', slug: 'pulau-tikus', population: 12000 },
      { name: 'Seri Kembangan', slug: 'seri-kembangan', population: 165000 },
      { name: 'Puchong', slug: 'puchong', population: 388000 },
      { name: 'Bangi', slug: 'bangi', population: 225000 },
      { name: 'Cheras', slug: 'cheras-selangor', population: 225000 },
      { name: 'Rawang', slug: 'rawang', population: 120000 },
      { name: 'Gombak', slug: 'gombak', population: 688000 },
      { name: 'Hulu Selangor', slug: 'hulu-selangor', population: 95000 },
      { name: 'Kuala Selangor', slug: 'kuala-selangor', population: 205000 },
      { name: 'Sabak Bernam', slug: 'sabak-bernam', population: 106000 },
      { name: 'Hulu Langat', slug: 'hulu-langat', population: 1230000 },
      { name: 'Sepang', slug: 'sepang-district', population: 212000 },
      { name: 'Kuala Langat', slug: 'kuala-langat', population: 222000 },
      { name: 'Tanjong Karang', slug: 'tanjong-karang', population: 45000 },
      { name: 'Banting', slug: 'banting', population: 48000 },
      { name: 'Jenjarom', slug: 'jenjarom', population: 15000 },
      { name: 'Teluk Panglima Garang', slug: 'teluk-panglima-garang', population: 25000 },
      { name: 'Morib', slug: 'morib', population: 12000 },
      { name: 'Kelanang', slug: 'kelanang', population: 8000 },
      { name: 'Jugra', slug: 'jugra', population: 5000 },
      { name: 'Dengkil', slug: 'dengkil', population: 35000 },
      { name: 'Salak Tinggi', slug: 'salak-tinggi', population: 25000 },
      { name: 'Klia', slug: 'klia', population: 15000 },
      { name: 'Labu', slug: 'labu', population: 45000 },
      { name: 'Mantin', slug: 'mantin', population: 25000 },
      { name: 'Setul', slug: 'setul', population: 18000 },
      { name: 'Pajam', slug: 'pajam', population: 12000 },
      { name: 'Lukut', slug: 'lukut', population: 35000 },
      { name: 'Si Rusa', slug: 'si-rusa', population: 15000 },
      { name: 'Linggi', slug: 'linggi', population: 25000 },
      { name: 'Pengkalan Kempas', slug: 'pengkalan-kempas', population: 18000 },
      { name: 'Senawang', slug: 'senawang', population: 85000 },
      { name: 'Ampangan', slug: 'ampangan', population: 35000 },
      { name: 'Rahang', slug: 'rahang', population: 25000 },
      { name: 'Rantau', slug: 'rantau', population: 45000 },
      { name: 'Gemencheh', slug: 'gemencheh', population: 15000 },
      { name: 'Tampin', slug: 'tampin', population: 95000 },
      { name: 'Gemas', slug: 'gemas', population: 35000 },
      { name: 'Batang Melaka', slug: 'batang-melaka', population: 15000 },
      { name: 'Alor Gajah', slug: 'alor-gajah', population: 155000 },
      { name: 'Masjid Tanah', slug: 'masjid-tanah', population: 48000 },
      { name: 'Merlimau', slug: 'merlimau', population: 25000 },
      { name: 'Nyalas', slug: 'nyalas', population: 12000 },
      { name: 'Sungai Udang', slug: 'sungai-udang', population: 35000 },
      { name: 'Ayer Keroh', slug: 'ayer-keroh', population: 65000 },
      { name: 'Batu Berendam', slug: 'batu-berendam', population: 45000 }
    ]
  }
];
